export const COMMON_LAYOUT = "COMMON_LAYOUT";
export const HOME_LAYOUT = "HOME_LAYOUT";
